// src/utils/toast.js
export const showMainToast = (message, type = "primary") => {
  const alertType = type === "error" || type === "failed" ? "danger" : type;
  const alertDiv = document.createElement("div");
  alertDiv.className = `alert alert-${alertType} alert-dismissible cookies-alert position-fixed top-0 end-0 m-3 shadow`;
  alertDiv.setAttribute("role", "alert");
  alertDiv.style.zIndex = 2000;

  alertDiv.innerHTML = `
      <div class="d-flex justify-content-between align-items-center">
        <p class="mb-0 flex-grow-1">${message}</p>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    `;

  document.body.appendChild(alertDiv);

  setTimeout(() => {
    alertDiv?.remove();
  }, 4000);
};
